import http from "./httpService";
import { getJwt } from "./authService";
import { NothingToDeclareTypes } from "../pages/NothingToDeclare";
const apiEndpoint = process.env.REACT_APP_API_URL + "/nothing-to-declare";

http.setJwt(getJwt()!);

export const postNothingToDeclare = async (params: NothingToDeclareTypes) => {
  const { data } = await http.post(apiEndpoint, { ...params });

  return data;
};

export const updateNothingToDeclare = async (params: any, id: string) => {
  delete params._id;
  delete params.__v;

  const { data } = await http.put(apiEndpoint + `/${id}`, { ...params });
  return data;
};

export default postNothingToDeclare;
